/*
 * @Author: zhangguoliang
 * @Date: 2022-11-16 13:52:42
 * @LastEditors: renmingming
 * @LastEditTime: 2023-01-10 15:00:12
 */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import layout from "@/layouts/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    redirect: "/home",
    component: layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "homePage" */ "@/views/index.vue")
      },
      {
        path: "/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "auth" */ "@/views/login/index.vue")
      },
      {
        path: "/register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "auth" */ "@/views/login/register.vue")
      },
      {
        path: "/changePass",
        name: "changePass",
        component: () =>
          import(/* webpackChunkName: "auth" */ "@/views/login/changePass.vue")
      },
      {
        path: "/updateMobile",
        name: "updateMobile",
        component: () =>
          import(
            /* webpackChunkName: "auth" */ "@/views/login/updateMobile.vue"
          )
      },
      {
        path: "/my",
        name: "my",
        component: () =>
          import(/* webpackChunkName: "auth" */ "@/views/my/index.vue")
      },
      {
        path: "/sub2/:page*",
        name: "sub2",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub2/index.vue")
      },
      {
        path: "/sub3/:page*",
        name: "sub3",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub3/index.vue")
      },
      {
        path: "/sub4/:page*",
        name: "sub4",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub4/index.vue")
      },
      {
        path: "/sub5/:page*",
        name: "sub5",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub5/index.vue")
      },
      {
        path: "/sub6/:page*",
        name: "sub6",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub6/index.vue")
      },
      {
        path: "/sub7/:page*",
        name: "sub7",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub7/index.vue")
      },
      {
        path: "/sub8/:page*",
        name: "sub8",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub8/index.vue")
      },
      {
        path: "/sub9/:page*",
        name: "sub9",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub9/index.vue")
      },
      {
        path: "/sub10/:page*",
        name: "sub10",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub10/index.vue")
      },
      {
        path: "/sub11/:page*",
        name: "sub11",
        component: () =>
          import(/* webpackChunkName: "sub" */ "@/views/sub11/index.vue")
      },
      {
        path: "/updatePassword",
        name: "updatePassword",
        component: () =>
          import(
            /* webpackChunkName: "auth" */ "@/views/updatePassword/index.vue"
          )
      },
      {
        path: "/integralCenter",
        name: "integralCenter",
        component: () =>
          import(
            /* webpackChunkName: "auth" */ "@/views/integralCenter/index.vue"
          )
      },
      {
        path: "/integralDetail",
        name: "integralDetail",
        component: () =>
          import(
            /* webpackChunkName: "auth" */ "@/views/integralCenter/integralDetail.vue"
          )
      },
      {
        path: "/news/detail",
        name: "newsDetail",
        component: () =>
          import(/* webpackChunkName: "newsDetail" */ "@/views/news/detail.vue")
      },
      {
        path: "/recruitment",
        name: "recruitment",
        component: () =>
          import(
            /* webpackChunkName: "auth" */ "@/views/recruitment/index.vue"
          )
      },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
});

export default router;
